import { INSTALLER_TABS } from 'config/constants';
import { can } from '../../../../services';

const hasIfiPermission = mvw => mvw && mvw.ifi === true;

export default function getAllowedInstallerTabs(role, mvw = {}) {
  return INSTALLER_TABS.filter((tab) => {
    if (tab.label === 'Millwork Certifications' && !hasIfiPermission(mvw)) {
      return false;
    }
    if (tab.fullInstallerUpdateOnly && !can(role, 'update', 'installer')) {
      return false;
    }
    return can(role, 'update', tab.ability) || can(role, 'update_basic', tab.ability);
  });
}



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/installerAllowedTabs.js